const gsapController = async function () {
    const numberContent = !!document.querySelector(".number-content");

    if ( numberContent  ) {
        let gsap = await (await import('gsap')).default;

        // ScrollTrigger
        if ( numberContent ) {
            let ScrollTrigger = await (await import('gsap/ScrollTrigger')).default;
            gsap.registerPlugin(ScrollTrigger);

            if ( numberContent ) {
                let AnimatedSection = await (await import('./gsap/numbers')).default;
                AnimatedSection(gsap, ScrollTrigger);
            }
        }
    }
};

export const init = gsapController;